export default Object.freeze([
  {
    value: 'Male',
    labelId: 'sexDropdown.male',
    defaultLabel: 'Male'
  },
  {
    value: 'Female',
    labelId: 'sexDropdown.female',
    defaultLabel: 'Female'
  }
]);